import moment, { Moment } from 'moment';
import isEmpty from 'lodash/isEmpty';
import 'moment/locale/es';
import 'moment/locale/pt';

export const DEFAULT_DATE_FORMAT = 'L';
export const EMPTY_DATE = '-';
interface FormatProps {
  date?: string | Date | Moment;
  displayFormat?: string;
  locale?: string;
  useUTC?: boolean;
}

/**
 * TODO: this should replace the current way to format dates
 * when there is time change all references
 */
const format = ({
  date,
  displayFormat = DEFAULT_DATE_FORMAT,
  locale = window.navigator.language,
  useUTC = false
}: FormatProps) => {
  if (isEmpty(date)) {
    return EMPTY_DATE;
  }

  const momentDate = useUTC ? moment.utc(date) : moment(date);
  return momentDate.locale(locale).format(displayFormat);
};

export const date = {
  format,
  formatDate: (date: any, dateFormat: string = DEFAULT_DATE_FORMAT) => {
    if (date === null) {
      return EMPTY_DATE;
    }
    return moment(date)
      .locale(window.navigator.language)
      .format(dateFormat);
  },
  toPrettyDateTime: (date?: string | Date) => {
    if (!date) {
      return;
    }
    date = String(date);
    const [day, time] = date.split('T');
    const [hours, minutes] = time.split(':');
    return `${day} ${hours}:${minutes}`;
  },
  todayAt00: () => {
    const todayAt00 = moment().utcOffset(0);
    todayAt00.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    todayAt00.toISOString();
    todayAt00.format();
    return todayAt00;
  },
  messageSentAtFormat: (
    date: Date,
    todayAt: Moment,
    todayFormat: string = 'HH:mm',
    fullDateFormat: string = 'MMM DD, YYYY - h:mm'
  ) => {
    const dateToDisplay = moment(date);
    const shouldDisplayFullFormatDate = dateToDisplay.isAfter(todayAt);
    return format({
      date: dateToDisplay,
      displayFormat: shouldDisplayFullFormatDate ? todayFormat : fullDateFormat
    });
  },
  fromNow: (date: Date) => {
    return moment.utc(date).fromNow();
  },
  addMonths: (date: any, months: number) => {
    if (date === null) {
      return EMPTY_DATE;
    }
    return moment(date)
      .add(months, 'months')
      .locale(window.navigator.language)
      .format(DEFAULT_DATE_FORMAT);
  }
};
